<script lang="ts">
	import { createEventDispatcher } from "svelte";
	
	import Button from "../../form/Button.svelte";
	import Modal from "../../shared/Modal.svelte";

	export let prompt: string | undefined;
	
	let dispatch = createEventDispatcher<{ done: boolean | undefined}>();

</script>


<Modal on:close={() => dispatch('done')}>
	<span slot="header" class="headline-s bold">{prompt ?? 'Are you sure?'}</span>
	<div class="max-w-600 m-auto">
		<Button type="button" onClick={() => dispatch('done', false)}>Cancel</Button>
		<Button type="button" onClick={() => dispatch('done', true)}>Continue</Button>
	</div>
</Modal>

